import { Outlet, useLocation } from 'react-router';
import { TenantLink } from '~/lib/navigation';

export default function SandboxWidgetLayout() {
  const location = useLocation();
  
  const steps = [
    { path: '/sandbox/widget', label: 'Step 1' },
    { path: '/sandbox/widget/step-2', label: 'Step 2' },
    { path: '/sandbox/widget/success', label: 'Success' },
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <div className="mb-6">
          <TenantLink to="/sandbox" preserveParams={false} className="text-sm text-muted-foreground hover:text-foreground">
            ← Back to sandbox home
          </TenantLink>
        </div>

        {/* Progress indicator */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            {steps.map((step, index) => (
              <div key={step.path} className="flex items-center">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    location.pathname === step.path
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted text-muted-foreground'
                  }`}
                >
                  {index + 1}
                </div>
                <span className="ml-2 text-sm">{step.label}</span>
                {index < steps.length - 1 && (
                  <div className="w-12 h-0.5 bg-muted mx-4" />
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Widget content */}
        <Outlet />
      </div>
    </div>
  );
}
